import { getSiteMode } from './app/utils/getSiteMode';
export * from '@nuxt-common/creditcard-banner-consumable/config.mcom.js';

const FRICTION_FREE_CATEGORY = 320264;
const ENTRY_POINT = '0000';
const LEARN_MORE_PARAM = '_learnMore';
const BOPS_ENTRY_POINT_URL = `/shop/pickup-delivery/Upc_bops_purchasable/${ENTRY_POINT}?id=${FRICTION_FREE_CATEGORY}`;

export const brand = 'mcom';
export const mobileTitles = {
  happeningNow: 'Happening Now',
  shopByDepartment: 'Shop by Department',
  shopByStore: 'Shop Your Store',
  moreToExplore: 'More to Explore',
};
export const appLinks = [
  {
    title: 'App Store',
    link: 'https://itunes.apple.com/US/app/id341036067?mt=8',
    img: 'appStore.svg',
  },
  {
    title: 'Google Play',
    link: 'https://play.google.com/store/apps/details?id=com.macys.android&hl=en_US',
    img: 'googlePlay.svg',
  },
];
export const getFlagUrl = (regionCode, getAssetImage) => getAssetImage(`${regionCode}.svg`, 'flags');
export const Links = {
  homepage: {
    site: {
      url: '/',
      tracking: {
        lid: (context) => `glbtopnav_macys_icon-${getSiteMode(context)}`,
        link_name: 'glbtopnav_macys_icon-us',
      },
    },
  },
  bag: {
    url: '/my/bag',
    tracking: {
      cm_sp: 'navigation-_-top_nav-_-bag',
      lid: (context) => `glbtopnav_bag-${getSiteMode(context)}`,
      link_name: 'glbtopnav_bag-us',
      page_name: 'shopping bag',
      page_type: 'shopping bag',
    },
  },
  store: {
    changeStore: {
      text: 'Change Store',
    },
    pickupAndDelivery: {
      text: 'Pickup & Delivery',
    },
    freeStorePickup: {
      url: BOPS_ENTRY_POINT_URL,
      text: 'Shop Free Store Pickup',
      pos: 2,
      tracking: {
        cm_sp: 'navigation-_-top_nav-_-shop-free-store-pickup',
      },
    },
    sameDayDelivery: {
      url: `/shop/pickup-delivery/Upc_sdd_purchasable/${ENTRY_POINT}?id=${FRICTION_FREE_CATEGORY}`,
      text: 'Shop Same-Day Delivery',
      pos: 3,
      tracking: {
        cm_sp: 'navigation-_-top_nav-_-shop-same-day-delivery',
      },
    },
    nextDayDelivery: {
      url: `/shop/pickup-delivery/Upc_sdd_purchasable/${ENTRY_POINT}?id=${FRICTION_FREE_CATEGORY}`,
      text: 'Shop Next-Day Delivery',
      pos: 3,
      tracking: {
        cm_sp: 'navigation-_-top_nav-_-shop-next-day-delivery',
      },
    },
    learnMore: {
      url: `${BOPS_ENTRY_POINT_URL}&${LEARN_MORE_PARAM}=true`,
      text: 'Learn more',
      pos: 4,
      tracking: {
        cm_sp: 'navigation-_-top_nav-_-learn-more',
      },
    },
  },
};
export const minimal = {
  links: {
    default: [
      {
        name: 'Privacy Notice',
        url: 'https://www.macys.com/customer-service/articles/highlights-of-macys-inc-notice-of-privacy-practices',
      },
      {
        name: 'Legal Notice',
        url: 'https://www.macys.com/customer-service/articles/legal-notice',
      },
      {
        name: 'Interest Based Ads',
        url: 'https://www.macys.com/customer-service/articles/macys-and-macyscom-notice-of-privacy-practices#interest-based-or-online-behavioral-advertising',
      },
    ],
    checkout: [
      {
        name: 'Privacy Policy',
        url: 'https://www.macys.com/customer-service/articles/highlights-of-macys-inc-notice-of-privacy-practices',
      },
      {
        name: 'Legal Notice',
        url: 'https://www.macys.com/customer-service/articles/legal-notice',
      },
      {
        name: 'Interest Based Ads',
        url: 'https://www.macys.com/customer-service/articles/macys-and-macyscom-notice-of-privacy-practices#interest-based-or-online-behavioral-advertising',
      },
      {
        name: 'Shipping Policy',
        url: 'https://www.macys.com/customer-service/category/shipping-delivery',
        tracking: {
          cm_sp: 'navigation-_-bottom_nav-_-shipping_%26_delivery',
          lid: 'glbbtmnav_shipping_%26_delivery-us',
        },
      },
      {
        name: 'Return Policy',
        url: 'https://www.macys.com/customer-service/category/returns',
        tracking: {
          cm_sp: 'navigation-_-bottom_nav-_-returns',
          lid: 'glbbtmnav_returns-us',
        },
      },
    ],
  },
  copyright: [`© ${new Date().getFullYear()} Macy’s. All rights reserved. Macys.com, LLC,`, '151 West 34th Street, New York, NY 10001'],
};
export const logoLabel = {
  site: "Macy's Home Page",
};
export const defaultStoreName = 'Find a Store';
export const searchPlaceholderTextMap = {
  short: 'Search',
  long: 'What are you looking for?',
};
export const registryLinkGroups = [
  {
    title: null,
    items: [
      {
        text: 'Find a registry',
        url: '/registry/search',
      },
      {
        text: 'Create a registry',
        url: '/registry',
      },
      {
        text: 'Wedding checklist',
        url: '/s/registry-guide/checklist/',
      },
      {
        text: 'Baby checklist',
        url: '/s/baby-registry/checklist/',
      },
      {
        text: 'FAQs',
        url: 'https://www.macys.com/customer-service/category/wedding-registry-gifts',
      },
    ],
  },
];
export const trendingQueriesFallback = [
  'Dressy Thong Sandals',
  'Statement Linen',
  'Soft & Flowy dresses',
  'Asymmetrical dresses',
  'Layered Necklaces',
  'Jellies',
  'Women’s formal dresses',
  'Women’s perfume',
  'Crafted Handbags & Shoes',
  'Two Tone Watches',
];

export * from '@nuxt-common/locator/config.mcom.js';
export * from '@nuxt-common/product-quickview/config.mcom.js';
export * from '@nuxt-common/media-card-large/config.mcom';

export * from './config.mcom.data';

export const askMacysPrompts = [
  'I need an outfit for an event',
  "What's trending this fall",
  'Help me find a gift',
  'Refresh my bedroom',
  'I need shoes for a special occasion',
  'Help me complete the look',
];
